// extracted by mini-css-extract-plugin
export default {"row":"lfQXzhUe59bz0QmN4dl9","title":"zZeuDnNmdatuZwH9q3at"};